import { render, staticRenderFns } from "./VulnerabilityList.vue?vue&type=template&id=d5e00288"
import script from "./VulnerabilityList.vue?vue&type=script&lang=ts"
export * from "./VulnerabilityList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,UICountBadge: require('/app/components/Common/UI2/Badge/UICountBadge.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,Paginator: require('/app/components/Dependencies/Target/Paginator.vue').default,VulnerabilityListItemSkeleton: require('/app/components/Dependencies/Target/VulnerabilityListItemSkeleton.vue').default,VulnerabilityListItem: require('/app/components/Dependencies/Target/VulnerabilityListItem.vue').default})
